// Historial de navegación propio de la SPA (memoria del tab, no persiste).
// AppLayout registra cada ruta visitada; BackButton pregunta de dónde venimos.
let stack: string[] = [];

/** Registrar la ruta actual (pathname + query). Ignora repeticiones consecutivas. */
export function recordNav(route: string) {
  if (stack[stack.length - 1] === route) return;
  stack.push(route);
  if (stack.length > 50) stack = stack.slice(-50);
}

/** Última ruta distinta a la actual (la pantalla desde la que se llegó), o null. */
export function prevRoute(): string | null {
  const current = stack[stack.length - 1];
  for (let i = stack.length - 2; i >= 0; i--) {
    if (stack[i] !== current) return stack[i];
  }
  return null;
}
